export default "__VITE_ASSET__NLpA8nAj__"